import { useState } from 'react'
import { api, type TokenQuotaBookings } from '../services/api'
import { forbiddenText } from '../lib/forbiddenText'
import { formatBookingDate, formatBookingMio, toTokenBookingRow } from '../utils/tokenBookings'
import TokenBookingsTable from './TokenBookingsTable'

// TQ #380: Drilldown zum Token-Kontingent-Balken — "wofuer zahle ich".
// Zeilen kommen live aus ERPNext (Token-Buchung, gefiltert auf das angezeigte Kontingent),
// Einheit ausschliesslich IT-SCE-Token (Mio), kein Euro-/Kursfeld. Wird erst beim Aufklappen
// geladen; Fehler zeigen eine kurze Meldung statt die Karte zu entfernen.
// TQ #960: Tabelle und Begriffe geteilt mit Token-Verlauf (TokenBookingsTable, utils/tokenBookings).

export default function QuotaBookingsDrilldown({ slug }: { slug: string }) {
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [data, setData] = useState<TokenQuotaBookings | null>(null)

  const toggle = async () => {
    const next = !open
    setOpen(next)
    if (!next || data) return
    setLoading(true)
    setError(null)
    try {
      setData(await api.getOrgTokenQuotaBookings(slug))
    } catch (e) {
      setError(forbiddenText(e) ?? 'Buchungen konnten nicht geladen werden.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="token-quota-drilldown" style={{ marginTop: 8 }}>
      <button
        type="button"
        onClick={toggle}
        aria-expanded={open}
        style={{ background: 'none', border: 'none', padding: 0, color: '#2563eb', cursor: 'pointer', fontSize: 13 }}
      >
        {open ? 'Buchungen ausblenden ▲' : 'Buchungen anzeigen ▼'}
      </button>
      {open && (
        <div style={{ marginTop: 8 }}>
          {loading && <span style={{ fontSize: 13, color: '#6b7280' }}>Lade Buchungen…</span>}
          {error && <span style={{ fontSize: 13, color: '#b91c1c' }}>{error}</span>}
          {data && data.bookings.length === 0 && (
            <span style={{ fontSize: 13, color: '#6b7280' }}>Noch keine Token-Buchungen.</span>
          )}
          {data && data.bookings.length > 0 && (
            <TokenBookingsTable
              compact
              showBeleg
              rows={data.bookings.map(toTokenBookingRow)}
              footer={{
                label: `Summe (Stand ${formatBookingDate(data.stichtag)})`,
                value: formatBookingMio(data.summe_einheiten_mio),
              }}
            />
          )}
        </div>
      )}
    </div>
  )
}
